import type {
  SettingsAgentPermissions,
  UpdateAgentPermissionInput,
  UpdateAgentPermissionsBatchInput,
} from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createAgentPermissionPoliciesClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    update: ({
      projectId,
      ...input
    }: { projectId: string } & UpdateAgentPermissionInput) => {
      return request<SettingsAgentPermissions>({
        method: "PATCH",
        path: `/api/v1/projects/${projectId}/agent-permission-policies`,
        body: input,
      });
    },
    updateMany: ({
      projectId,
      ...input
    }: { projectId: string } & UpdateAgentPermissionsBatchInput) => {
      return request<SettingsAgentPermissions>({
        method: "PATCH",
        path: `/api/v1/projects/${projectId}/agent-permission-policies/batch`,
        body: input,
      });
    },
  };
}
